import React from 'react';
import TermLengths from '../../../Lists/CoverageLengths/AmericoCoverageLengths';
import ProductSpecificationsData from './ProductSpecificationsData';
import MarketingData from './MarketingData';
import PurchasingProcessData from './PurchasingProcessData';
import Americo from "../../../../Quoters/Americo/Americo";
import FaqData from './FaqData';
export default function ProductInfo() {
  const minAge = 20;
  const maxAge = 65;
  const minCoverageAmount = 10000;
  const maxCoverageAmount = 1000000;
  return {
    name: 'Loan Protection Life Insurance',
    abbr: 'americo',
    subtitle: 'Protect Your Mortgage or Business Loan',
    footerMessage: 'Get loan protection life insurance from start to finish completely online.',
    basicInfoForm: (history) => {
      return <Americo landing history={history} />
    },
    specs: {
      age: { min: minAge, max: maxAge },
      coverageAmount: { min: minCoverageAmount, max: maxCoverageAmount }
    },
    about: {
      title: 'Only Pay for What You Need',
      content: "LoanMatch Protector is an instant-decision life insurance product that offers highly competitive rates, an easy online application process, and no medical exam requirement. This unique product mirrors the length and balance of a loan as it’s paid down, so you’ll never pay more than you need to."
    },
    productSpecifications: ProductSpecificationsData(minAge, maxAge, minCoverageAmount, maxCoverageAmount, TermLengths()),
    marketing: MarketingData(),
    purchasingProcess: PurchasingProcessData(),
    faq: FaqData(),
    isAddDefaultFaq: false,
  }
}



// WEBPACK FOOTER //
// ./src/components/Helpers/Data/Products/Americo/ProductInfo.js